import React from 'react';
import Hero from './Hero';
import VisionMissionSection from './VisionMissionSection';
import WorkShowcase from './WorkShowcase';
import SuccessfulCampaignCaseStudies from './SuccessfulCampaignCaseStudies';
import About from './About';
import PoliticalWins from './PoliticalWins';
import BestGraphicsPortfolio from './BestGraphicsPortfolio';
import Portfolio from './Portfolio';
import Process from './Process';
import Contact from './Contact';

const HomePage = () => {
  return (
    <main>
      <Hero />
      <VisionMissionSection />
      <PoliticalWins />
      <BestGraphicsPortfolio />
      <WorkShowcase />
      <SuccessfulCampaignCaseStudies />
      <Portfolio />
      <Process />
      <Contact />
    </main>
  );
};

export default HomePage;
